<template>
  <div>
    <div class="content">
      <span class="userNameClass" :title="post.userName">{{ post.userName.substring(0, 5) + (post.userName.length > 5 ? '···' : '') }}</span>
      <span class="contentClass" :title="post.userName">
        <span
          v-if="showAllContent || post.content.length < 3 * 76"
          @click="showAllContent = false"
        >
          {{ post.content }}
        </span>
        <span v-else @click="showAllContent = true">
          {{ post.content.substring(0, 3 * 76 - 4) }}...
        </span>
      </span>
      <span class="contentAppendInfoClass">
        <el-button
          title="查看回复"
          icon="el-icon-chat-dot-round"
          circle
          @click="goIntoOneContent(post.postId, post.content)"
        ></el-button>
        <span class="contentAppendInfoDateTimeClass">
          {{ new Date(post.addTime).toLocaleString() }}
        </span>

        <mainPostDeleteCom
          class="deleteElementClass"
          :userOwnThePost="post.userOwnThePost"
          :postId="post.postId"
          v-on:flushDateEvent="flushFirstPageListFun"
        ></mainPostDeleteCom>
      </span>
    </div>
    <div v-if="showSubListOrNot" class="subListClass">
      <subReplyListCom
        :appendPostId="choosedMainPostId"
        :subReplyAppendPostContent="choosedMainPostContent"
      ></subReplyListCom>
    </div>
  </div>
</template>

<script>
import mainPostDeleteCom from './postDelete.vue'
import subReplyListCom from '../subPostList/subPostList.vue'
export default {
  props: {
    index: Number,
    post: Object
  },
  data () {
    return {
      showAllContent: false,
      choosedMainPostId: Number,
      choosedMainPostContent: String,
      showSubListOrNot: false
    }
  },
  methods: {
    goIntoOneContent (postId, content) {
      // this.$emit('goIntoOneContentEvent', postId, content)
      this.choosedMainPostId = postId
      this.choosedMainPostContent = content
      this.showSubListOrNot = !this.showSubListOrNot
    },
    flushFirstPageListFun () {
      this.$emit('flushFirstPageDataListEvent')
    }
  },
  components: {
    mainPostDeleteCom,
    subReplyListCom
  }
}
</script>

<style scoped>
.content {
  width: 100%;
  background-color: white;
  color: black;
  padding-top: 1rem;
  padding-bottom: 1rem;
  border-radius: 0.1rem;
  border-bottom: 0.03rem solid black;
  font-size: 1rem;

  display: flex;
  flex-direction: row;
  justify-content: baseline;
  align-items: flex-start;
}
.idClass {
  margin-left: 2rem;
}
.contentClass {
  width: 80%;
}
.userNameClass {
  width: 6%;
  text-align: right;
  padding-left: 2%;
  padding-right: 1%;
}
.deleteElementClass {
  display: inline-block;
}
.contentAppendInfoClass {
  margin-bottom: -1rem;
  font-size: 0.6rem;
  align-self: flex-end;
  margin-left: auto;
  margin-right: 2%;
  width: 13%;
  text-align: right;
}
.subListClass {
  background-color: white;
  color: black;
  padding-left: 9%;
  padding-right: 9%;
}
.contentAppendInfoDateTimeClass {
  display: inline-block;
  width: 60%;
}
</style>
